import { Entity, TenantSubscription } from '../../entities';
import { TenantPlan } from '../../security';

import * as Enumerable from 'linq';
import { BaseSecurityModule } from '../base.security.module';
import { AppSecurityModule, ConfigurationSecurityModule, ConfigurationSecurityRight, ConfigurationSubModule, FinanceSecurityModule, IndividualComplianceSecurityModule, IndividualComplianceSecurityRight, JobSecurityModule, MobileTechniciansSecurityModule, QuoteSecurityModule, SchedulerSecurityModule, TimesheetSecurityModule, WorkComplianceSecurityModule, WorkComplianceSecurityRight, PortalClientSecurityModule, PortalContractorSecurityModule, KnowledgeBaseSecurityModule, ClaimSecurityModule, CrmSecurityModule, ReportSecurityModule, VariationSecurityModule, AssetSecurityModule, DefectSecurityModule, RecurringJobSecurityModule, TaskSecurityModule, JobTemplatesSecurityModule, SalesSecurityModule, DashboardSecurityModule, QuoteTemplatesSecurityModule, AppSecurityRight, MobileTechniciansSecurityRight, ProjectsSecurityModule, JobTemplateSecurityRight, CrmSecurityRight, AddressValidationSecurityModule, EnterpriseSearchSecurityModule, PropertyManagementSecurityModule, WorkBuddyConnectSecurityModule, EquipmentSecurityModule, LocationSecurityModule } from '../modules';
import { FormSecurityModule, FormSecurityRight } from '../modules/form.security.module';
import { SecurityModule, SecurityModuleName } from '../security.module';

export class SecurityModuleUtility {

    public static systemModules: BaseSecurityModule<any>[] = [
        new AppSecurityModule(),
        new QuoteSecurityModule(),
        new TimesheetSecurityModule(),
        new TaskSecurityModule(),
        new IndividualComplianceSecurityModule(),
        new ConfigurationSecurityModule(),
        new FinanceSecurityModule(),
        new SchedulerSecurityModule(),
        new CrmSecurityModule(),
        // new PurchaseOrderSecurityModule(),
        new WorkComplianceSecurityModule(),
        new MobileTechniciansSecurityModule(),
        new PortalClientSecurityModule(),
        new PortalContractorSecurityModule(),
        new KnowledgeBaseSecurityModule(),
        new ClaimSecurityModule(),
        new ReportSecurityModule(),
        new VariationSecurityModule(),
        new DefectSecurityModule(),
        new AssetSecurityModule(),
        new RecurringJobSecurityModule(),
        new JobTemplatesSecurityModule(),
        new QuoteTemplatesSecurityModule(),
        new SalesSecurityModule(),
        new DashboardSecurityModule(),
        new FormSecurityModule(),
        new ProjectsSecurityModule(),
        new JobSecurityModule(),
        new AddressValidationSecurityModule(),
        new EnterpriseSearchSecurityModule(),
        new PropertyManagementSecurityModule(),
        new WorkBuddyConnectSecurityModule(),
        new EquipmentSecurityModule(),
        new LocationSecurityModule(),
    ];

    public static getConfigurationSubAccessModules(rights: number[]): ConfigurationSubModule[] {

        if (!rights?.length) return [];

        const modules: ConfigurationSubModule[] = [];

        Enumerable.from(rights).forEach(x => {

            switch (x) {
                case ConfigurationSecurityRight.AccessPricing:
                    modules.push(ConfigurationSubModule.Pricing);
                    break;

                case ConfigurationSecurityRight.AccessMetadata:
                    modules.push(ConfigurationSubModule.Metadata);
                    break;

                case ConfigurationSecurityRight.AccessTemplates:
                    modules.push(ConfigurationSubModule.Templates);
                    break;
                case ConfigurationSecurityRight.AccessTenancy:
                    modules.push(ConfigurationSubModule.Tenancy);
                    break;
                case CrmSecurityRight.ManageSecurityRoles:
                    modules.push(ConfigurationSubModule.Security);
                    break;
                // case UserSecurityRight.CanAccess:
                //     modules.push(ConfigurationSubModule.User);
                //     break;
                // case UserSecurityRight.ManageSecurityRole:
                //     modules.push(ConfigurationSubModule.Security);
                //     break;

                case IndividualComplianceSecurityRight.ManageComplianceRules:
                    modules.push(ConfigurationSubModule.IndividualCompliance);
                    break;

                case WorkComplianceSecurityRight.ManageComplianceRules:
                    modules.push(ConfigurationSubModule.WorkCompliance);
                    break;

                default:
                    break;


            }
        });

        return modules;
    }

    public static getModuleById(moduleId: string): SecurityModule<any> {

        const selectedModule = Enumerable.from(SecurityModuleUtility.systemModules)
            .firstOrDefault(x => x._id === moduleId);

        return selectedModule;

    }

    public static getPlanModules(): Entity[] {

        return Enumerable
            .from(SecurityModuleUtility.systemModules)
            .where(x => x.plan !== TenantSubscription.System)
            .select(x => {
                return {
                    _id: x._id,
                    name: x.name,
                    data: x.plan
                } as Entity;
            })
            .orderBy(x => x.name)
            .toArray();
    }

    public static getPlanRightsMask(plan: TenantPlan): number[] {

        const disabledRights: number[] = [];

        if (!plan) return disabledRights;

        const moduleRights = Enumerable
            .from(SecurityModuleUtility.systemModules)
            .where(x => x.plan !== TenantSubscription.System)
            .toDictionary(x => x._id, x => x.allRights);

        const disabledModules = this.getPlanDisabledModules(plan);

        Enumerable
            .from(disabledModules)
            .forEach(disabledId => {
                if (!moduleRights.contains(disabledId)) return;
                disabledRights.push(...moduleRights.get(disabledId));
            });

        if (disabledModules.includes(SecurityModuleName.PortalContractors))
            disabledRights.push(AppSecurityRight.LoginContractor);

        if (disabledModules.includes(SecurityModuleName.PortalClients))
            disabledRights.push(AppSecurityRight.LoginClient);

        if (disabledModules.includes(SecurityModuleName.Assets)) {
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobManageAssets);
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewAssets);
        }

        if (disabledModules.includes(SecurityModuleName.Tasks))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewTasks);

        if (disabledModules.includes(SecurityModuleName.Defects))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewDefects)

        if (disabledModules.includes(SecurityModuleName.Finance))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewInvoices)

        switch (plan.subscription) {
            case TenantSubscription.Core:
                disabledRights.push(AppSecurityRight.LoginManager);
                disabledRights.push(JobTemplateSecurityRight.CanAccess, JobTemplateSecurityRight.Manage);
                disabledRights.push(FormSecurityRight.CanAccessForms, FormSecurityRight.CreateEditForms, FormSecurityRight.DeleteForms, FormSecurityRight.ModifyAfterSubmission);
                disabledRights.push(MobileTechniciansSecurityRight.ManagePurchaseOrders, MobileTechniciansSecurityRight.CanAccessPurchaseOrders);
                break;

            case TenantSubscription.Professional:
                break;

            case TenantSubscription.Enterprise:
                break;

        }

        return disabledRights;
    }

    public static getPlanDisabledModules(plan: TenantPlan): string[] {

        if (!plan) return [];

        const disabledFeatures = Enumerable
            .from(Object.keys(plan.features))
            .where(featureKey => !plan.features[featureKey])
            .toArray();

        const disabledAddons = Enumerable
            .from(Object.keys(plan.addons))
            .where(featureKey => !plan.addons[featureKey])
            .toArray();

        const disabledModules = [...disabledFeatures, ...disabledAddons];

        return disabledModules;
    }


}
